import { TextField } from "@mui/material";
import { useEffect, useState } from "react";

export default function  DebouncedTextField({ value, onChange, delay = 800, ...props }) {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    const t = setTimeout(() => {
      if (localValue !== value) onChange(localValue);
    }, delay);

    return () => clearTimeout(t);
  }, [localValue]);

  return (
    <TextField
      {...props}
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
    />
  );
}
